/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { provideHttpClient } from "@angular/common/http";
import { routes } from "./app/app.routes";
import { provideRouter } from "@angular/router";
import { applyBrandTheme } from "./app/shared/theme/brand-theme";

if (typeof document !== "undefined") {
  applyBrandTheme(document.documentElement);
}

bootstrapApplication(AppComponent, {
  providers: [provideRouter(routes), provideHttpClient()],
}).catch((err) => console.error(err));
